module.exports = __webpack_public_path__ + "static/icon_phone-871356b8aac2de25af3c400f15be4a38.png";